import { useState } from "react";

import { NotificationExpandToggle } from "./NotificationExpandToggle";
import { Column, Row, Text } from "@/components";

import { MIXPANEL_NOTIFICATION_SURFACES } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import { NotificationLeaderboardDailyPayload, NotificationType } from "@/types";

export const NotificationLeaderboardDailyList = ({
  isCompact = false,
  payload,
  trackingSurface,
}: {
  isCompact?: boolean;
  payload: NotificationLeaderboardDailyPayload;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { rankings, teamTotal } = payload;

  const render = () => (
    <Column className="gap-0.5">
      <NotificationExpandToggle
        isExpanded={isExpanded}
        notificationType={NotificationType.LEADERBOARD_DAILY}
        setIsExpanded={setIsExpanded}
        trackingSurface={trackingSurface}
      >
        Team total: {teamTotal} {teamTotal === 1 ? "submit" : "submits"}
      </NotificationExpandToggle>
      {isExpanded ? (
        <Column className="gap-1 border-l border-slate-200 pl-3 pt-1">
          {rankings.map((entry, index) => (
            <Column key={entry.userId} className="gap-0 px-2 py-1.5">
              <Row className="items-center gap-1.5">
                <Text className="w-4 shrink-0 text-xs font-semibold text-slate-400">
                  {index + 1}
                </Text>
                <Text className={cn("text-sm", isCompact && "text-xs")}>
                  {entry.fullName}
                </Text>
                <Text className="text-xs font-normal text-slate-500">
                  {entry.submitCount}
                </Text>
              </Row>
              {entry.note ? (
                <Text className="pl-[22px] text-xs font-normal text-slate-500">
                  {entry.note}
                </Text>
              ) : null}
            </Column>
          ))}
        </Column>
      ) : null}
    </Column>
  );

  return render();
};
